import customerFeedbackEvents from "./new-events/customer-feedback-events";
import navigationEvents from "./new-events/navigation-events";
import pageViewEvents from "./new-events/page-view-events";
import signInEvents from "./new-events/sign-in-events";
import createRoomEvents from "./new-events/create-room-events";
import styleQuizEvents from "./new-events/style-quiz-events";
import roomEvents from "./new-events/room-events";
import sugarcubeEvents from "./new-events/sugarcube-events";
import roomPageEvents from "./new-events/room-page-events";
import faqEvents from "./new-events/faq-events";
import optimizelyEvents from "./new-events/optimizely-events";
import generic from "./new-events/generic";

const analyticsEvents = {
  pageView: pageViewEvents,
  navigationEvent: navigationEvents,
  createRoomEvent: createRoomEvents,
  signInEvent: signInEvents,
  customerFeedbackEvent: customerFeedbackEvents,
  styleQuizEvent: styleQuizEvents,
  roomPageEvent: roomPageEvents,
  faqEvent: faqEvents,
  optimizelyEvent: optimizelyEvents,
  generic: generic,
  ...sugarcubeEvents,
  ...roomEvents,
};

export default analyticsEvents;
